<template>
  <div class="view view__landing_reportscheduledcsvdownload">
    <component-loading></component-loading>
  </div>
</template>

<script>

import ComponentLoading from '@/components/default/shared/ComponentLoading'
export default {
  name: 'landing-report-scheduled-csv-download',
  components: { ComponentLoading },
  computed: {
    routeParamsReportId () {
      return this.$route.params.reportId
    },
    routeParamsResultId () {
      return this.$route.params.resultId
    }
  },
  methods: {
    generateReport () {
      this.$store.dispatch('ebsReportBuilderGenerateReportResultCSV', {
        reportId: this.routeParamsReportId,
        resultId: this.routeParamsResultId
      }).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Scheduled report downloaded',
          status: 'success'
        })
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Scheduled report not downloaded',
          status: 'error'
        })
      }).finally(() => {
        this.$router.push({ name: 'default' })
      })
    }
  },
  mounted () {
    this.generateReport()
  }
}
</script>
